<template>
    <BreadCrumb PageTitle="Ajouter les membres aux postes" />
    <AddAssign/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddAssign from "@/components/Assignations/AddAssign.vue";
  
    export default defineComponent({
      name: "AddAssignPage",
      components: {
        BreadCrumb,
        AddAssign,
      },
    });
  </script>